var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.225434 5.70369H4.08956V9.56782C4.08956 9.75143 4.23842 9.90028 4.42203 9.90028C4.60564 9.90028 4.75449 9.75143 4.75449 9.56782V5.70369H8.61862C8.80223 5.70369 8.95108 5.55484 8.95108 5.37123V5.37118C8.95102 5.18761 8.80221 5.03876 8.61858 5.03876H4.75447V1.17465C4.75447 0.991041 4.60562 0.842187 4.42201 0.842187C4.2384 0.842187 4.08954 0.991041 4.08954 1.17465V5.03878H0.22546C0.225451 5.03878 0.225443 5.03878 0.225434 5.03878C0.0418094 5.03876 -0.107031 5.18763 -0.107031 5.37123C-0.107031 5.55484 0.0418226 5.70369 0.225434 5.70369Z","fill":"#231F20","stroke":"black","strokeWidth":"0.3"}));
}

Plus.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
